

function Page( {title}) {

    return (
        <div >
            <h1>{title}</h1>
        </div>
    );
}

export default Page;
